import { ForwardedRef, RefCallback, useCallback } from "react";
import { useArrayMemo } from "./useArrayMemo";

/** Combines multiple refs into a single ref */
export function useCombinedRef<T>(
  ...refs: (ForwardedRef<T> | undefined)[]
): RefCallback<T> {
  const memoizedRefs = useArrayMemo(refs);

  return useCallback(
    (value) => {
      memoizedRefs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref) {
          ref.current = value;
        }
      });
    },
    [memoizedRefs],
  );
}
